import { CALL_API } from './api'
import moment from 'moment-timezone'
import {
    getBSRSToken,
    CORE_API_ENDPOINT,
    setRefreshToken,
    getTokenExpire,
    getTimeZone
} from 'Lib'

export default store => next => action => {
    const entry = action[CALL_API]

    if (typeof entry !== 'object') return next(action)

    const expire = getTokenExpire()

    const currentTime = moment().tz(getTimeZone())
    const duration = moment.duration(moment.unix(expire).diff(currentTime))
    const minutes = duration.asMinutes()
    if (minutes < 5) {
        fetch(`${CORE_API_ENDPOINT}/user/newtoken`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getBSRSToken()}`
            },
        })
            .then(res => res.json())
            .then(json => setRefreshToken(json))
            .then(() => next(action))
    } else {
        next(action)
    }
    // }else{
    //     next(action)
    // }  
}


// WEBPACK FOOTER //
// ./src/middlewares/checkToken.js